module.exports = __webpack_public_path__ + "img/g_and_f_smallx2.1e4a8089.png";